import Experience from "@folio-2026/experience"
import { EVENTS } from "@folio-2026/shared"
import { ButtonEvent, TextScene } from "@folio-2026/text"

export default class BackCTA {
  experience: Experience
  textScene: TextScene
  id: string = "back-to-loader-cta"

  constructor({ textScene }: { textScene: TextScene }) {
    this.experience = Experience.getInstance()

    this.textScene = textScene

    this.setEventListeners()
  }

  setEventListeners() {
    this.experience.on(EVENTS.About.Entered, this.reveal.bind(this))
    this.experience.on(EVENTS.About.Exiting, this.leave.bind(this))

    this.experience.on(
      EVENTS.About.LeaveCTA.Click,
      this.clickHandler.bind(this),
    )
    this.experience.on(
      EVENTS.About.LeaveCTA.Hover,
      this.hoverHandler.bind(this),
    )
    this.experience.on(EVENTS.About.EnterCTA.Out, this.outHandler.bind(this))
  }

  hoverHandler(e: unknown) {
    const event = e as ButtonEvent
    const { htmlElement } = event

    if (htmlElement.id !== this.id) {
      return
    }
  }

  outHandler(e: unknown) {
    const event = e as ButtonEvent
    const { htmlElement } = event

    if (htmlElement.id !== this.id) {
      return
    }
  }

  clickHandler(e: unknown) {
    const event = e as ButtonEvent
    const { htmlElement } = event

    if (htmlElement.id !== this.id) {
      return
    }

    this.experience.navigate("/")
  }

  reveal() {
    this.textScene.smallButtons
      .filter((button) => button.id === this.id)
      .forEach((button) => {
        button.reveal()
      })
  }

  leave() {
    this.textScene.smallButtons
      .filter((button) => button.id === this.id)
      .forEach((button) => button.dispose())

    this.textScene.smallButtons = this.textScene.smallButtons.filter(
      (button) => button.id !== this.id,
    )
  }
}
